// extracted by mini-css-extract-plugin
module.exports = {"submit":"LoginForm_submit__TJAmI","register":"LoginForm_register__fBdve"};